/* eslint-disable */
import React from 'react';
import { useHistory } from 'react-router-dom';
import styles from '../HomePageLayout.module.css';

const SubNode = ({ label, imgSrc, borderColor = '#000', historypath }) => {

  const history = useHistory()

  const RedirectToPage = (PageName) => {

    const pageRoutes = {
      "R2R": "/Record-To-Report",
      "H2R": "/Hire-To-Retire",
      "O2C": "/Order-To-Cash",
      "P2P": "/Procure-To-Pay",
      "Direct Tax": "/Direct-Tax",
      "Indirect Tax": "/Indirect-Tax",
      "Legal": "/Legal-Page",
      "Transition": "/Transition-Page",
      "Transformation": "/Process-Excellence",
      "Quality": "/Quality",
      "Talent": "/Talent-Page",
      "Finance": "/Finance-Page",
    };

    if (pageRoutes[PageName]) {
      history.push(pageRoutes[PageName]);
    }
  }

  const hexToRgb = (hex) => {
    const cleanHex = hex.replace('#', '');
    const bigint = parseInt(cleanHex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `${r}, ${g}, ${b}`;
  };

  return (
    <div
      className={`${styles.circle} ${styles.nodeCircle} d-flex flex-column align-items-center text-black`}
      style={{ border: `thick solid ${borderColor}`, '--shadow-color': `0 0 25px rgba(${hexToRgb(borderColor)}, 0.925)` }}
      onClick={(e) => {
        const value = e.target.alt;
        RedirectToPage(value)
      }}
    >
      <span className={styles.fwBoldCustom} >{label}</span>
      {imgSrc && <img className={styles.homeImage} src={imgSrc} alt={label} />}
    </div>
  )
};

export default SubNode;